type BackoffOptions = {
  baseMs: number;
  maxMs: number;
};

export function calculateBackoffMs(
  attemptCount: number,
  { baseMs, maxMs }: BackoffOptions
): number {
  return Math.min(baseMs * Math.pow(2, attemptCount), maxMs);
}
